import {
    bigModalsMetrics,
    COMPETITORS_MODAL_WIDTH,
    COMPETITORS_MODAL_WIDTH_BIG,
    CONTENT_STYLES,
} from "app/pages/benchmark-tracker/components/Report/CompetitorsModal/constants";
import type { BenchmarkMetricName } from "app/pages/benchmark-tracker/types/api.types";

export const getContentStyles = (metricName: BenchmarkMetricName) => {
    const width = bigModalsMetrics.includes(metricName) ? COMPETITORS_MODAL_WIDTH_BIG : COMPETITORS_MODAL_WIDTH;

    return { ...CONTENT_STYLES, width };
};
